import { Fragment } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

//components
import GroupStageTeam from './GroupStageTeam'

//constants
import { months } from '../../Constants'

const MatchesByGroup = (props) => {
	const {
		group,
		errors,
		handleSubmitForm,
		matches,
		onSubmitForm,
		register,
		teams,
		urlAssets,
	} = props

	const daysOfWeek = 7
	const today = dayjs().format('YYYY-MM-DD')

	const getFormattedNumberMonth = (monthName) => {
		const numberOfMonth = months.findIndex((m) => m === monthName) + 1
		return numberOfMonth < 10 ? `0${numberOfMonth}` : numberOfMonth
	}

	const getBgColor = (matchDate, today, finished) => {
		const splittedMatchDate = matchDate.split(' ')
		const nextMatchDate = dayjs(
			`${dayjs().year()}-${getFormattedNumberMonth(splittedMatchDate[3])}-${splittedMatchDate[1]}`,
		)

		if (finished) return 'bg-played-match text-white'
		if (nextMatchDate.diff(today, 'day') < daysOfWeek) {
			return 'bg-current-match text-unselected'
		}
		return 'bg-future-match text-unselected'
	}

	// ✅ evita crash si matches viene undefined/null
	const safeMatches = Array.isArray(matches) ? matches.filter(Boolean) : []

	return (
		<section className="">
			<h2 className="text-center group-name">GRUPO {group}</h2>

			<form key={group} onSubmit={handleSubmitForm(onSubmitForm)}>
				<section className="row mx-auto px-0">
					{safeMatches.map((match, index) => {
						let dateMatch = Math.ceil((index + 1) / 2)

						const stadiumRaw = match?.stadium || ''
						const matchStadium = stadiumRaw.includes(',')
							? stadiumRaw.split(',')
							: ['', stadiumRaw]

						const homeTeam = teams?.[match.home]
						const awayTeam = teams?.[match.away]

						return (
							<Fragment key={match.matchNumber}>
								<input
									type="hidden"
									{...register('group')}
									value={group}
								/>

								<article className="col-12 d-flex align-items-center justify-content-center mb-2 text-center">
									<span className="date-match">
										FECHA {dateMatch}
										{/* (Partido {match?.matchNumber}) */}
									</span>
								</article>

								<GroupStageTeam
									group={group}
									// paddingContainer="ps-1 ps-md-2 pe-0"
									direction="flex-row"
									marginTeamName="ms-1"
									slug={homeTeam?.slug || 'default'}
									team="Home"
									teamId={match?.home}
									teamName={homeTeam?.name || match.home}
									urlAssets={urlAssets}
									matchNumber={match?.matchNumber}
									bgColor={getBgColor(
										match?.matchDate,
										today,
										match?.completedApi,
									)}
									goals={match?.goalsHome}
									finished={match?.finished}
									completed={match?.completedApi}
									register={register}
									errors={errors}
								/>

								<GroupStageTeam
									group={group}
									// paddingContainer="pe-1 pe-md-2 ps-0"
									direction="flex-row-reverse"
									marginTeamName="me-1"
									slug={awayTeam?.slug || 'default'} // ✅ FIX
									team="Away"
									teamId={match?.away}
									teamName={awayTeam?.name || match?.away} // ✅ FIX
									urlAssets={urlAssets}
									matchNumber={match?.matchNumber}
									bgColor={getBgColor(
										match?.matchDate,
										today,
										match?.completedApi,
									)}
									goals={match?.goalsAway}
									finished={match?.finished}
									completed={match?.completedApi}
									register={register}
									errors={errors}
								/>

								<article className="col-12 d-flex align-items-center justify-content-center mb-2 text-center">
									<span className="match-data">
										{/* {(matchStadium[1] || '').trim()} -{' '} */}
										{(matchStadium[0] || '').trim()} -{' '}
										{match?.matchDate
											? `${match.matchDate.charAt(0).toUpperCase()}${match.matchDate.slice(1)}`
											: ''}{' '}
										- {match?.matchHour || ''}{' '}
										<b>/ TV: DIRECTV</b>
									</span>
								</article>
							</Fragment>
						)
					})}

					<section className="col-12 d-flex justify-content-center my-3">
						<button
							className="btn shadow px-3 py-2 btn-next text-white"
							type="submit"
							disabled={safeMatches.every(
								(m) => m?.completedApi,
							)}>
							Calcular
						</button>
					</section>
				</section>
			</form>
		</section>
	)
}

export default MatchesByGroup

MatchesByGroup.propTypes = {
	group: PropTypes.string.isRequired,
	errors: PropTypes.object.isRequired,
	handleSubmitForm: PropTypes.func.isRequired,
	matches: PropTypes.array.isRequired,
	onSubmitForm: PropTypes.func.isRequired,
	register: PropTypes.func.isRequired,
	teams: PropTypes.object.isRequired,
	urlAssets: PropTypes.string.isRequired,
}
